// extracted by css-extract-rspack-plugin
export default {"dialog":"LinkMailboxDialog_dialog__VjLpL"};